import { TIMELINE_BY_ID } from 'game/constants/Constants';
import { uuidv4 } from 'game/utils/Uuid';
import { doc } from 'prettier';

const SERIALISE_KEYS = [];
const MODEL_ID = 'player';

const DEFAULT_PLAYER_DATA = {
  currentTimeIndex: 0,
  playersChoicesByScenarioId: {},
  score: {},
};

export const UUID = uuidv4();

export class PlayerModel {
  constructor(saves, id) {
    this.saves = saves;
    // this.load();

    this._playerProgress = DEFAULT_PLAYER_DATA;

    this._seenOnboarding = {
      documents: false,
      decision: false,
    };

    // tracking data
    this.uuid = UUID;
    this.timesPlayedGame = 0;
    this.sessionStarted = 0;
    this.playersData = {};
  }

  /*
   * Save Methods
   */
  load() {
    this.saves.deserialize(this, MODEL_ID);
    this.save();
  }

  save() {
    const data = this.saves.serialize(this, MODEL_ID, SERIALISE_KEYS);
    this.saves.save({ data });
  }

  resetPlayersData() {
    this._playerProgress.currentTimeIndex = 0;
    this._playerProgress.playedScenariosById = [];
    this._playerProgress.score = {};
  }

  // ------------------------------
  // Player Time Progress
  // ------------------------------

  updateCurrentTime() {
    this._playerProgress.currentTimeIndex++;
  }

  playerHasReachehdEndOfTime() {
    return this._playerProgress.currentTimeIndex === 15;
  }

  // ------------------------------
  // Player Choices
  // ------------------------------
  getPlayersChoiceByScenarioId(id) {
    return this._playerProgress.playersChoicesByScenarioId[id] || false;
  }

  /*
   * Getters/Setters
   */

  set trackingPlaySession(data) {
    this.timesPlayedGame++;

    if (this.playersData[`play_session_${this.timesPlayedGame}`] == null) {
      this.playersData[`play_session_${this.timesPlayedGame}`] = {};
    }

    this.sessionStartTime = Date.now();

    // console.log('trackingPlaySession', this.playersData);
  }

  set trackingScenarioId(data) {
    if (this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order == null) {
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order = {};
    }

    if (
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ] == null
    ) {
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ] = {};
    }

    this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
      this._playerProgress.currentTimeIndex + 1
    ] = {
      scenarios_id: data.id,
    };

    // console.log('trackingScenarioId', this.playersData);
  }

  set setScenarioDocuments(data) {
    if (
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ].documents_read == null
    ) {
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ].documents_read = [];
    }

    if (
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ].documents_read.indexOf(data.doc_name) == -1
    ) {
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ].documents_read.push(data.doc_name);
    }

    // console.log('setScenarioDocuments', this.playersData);
  }

  set updatePlayedScenarios(data) {
    const { id, choice } = data;
    this._playerProgress.playersChoicesByScenarioId[id] = choice;

    if (
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ].players_choice == null
    ) {
      this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
        this._playerProgress.currentTimeIndex + 1
      ].players_choice = '';
    }
    this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
      this._playerProgress.currentTimeIndex + 1
    ].players_choice = choice;

    // console.log('updatePlayedScenarios', this.playersData);
  }

  set setPlayersOutcome(data) {
    const { scores, status, result } = data;
    if (this.playersData[`play_session_${this.timesPlayedGame}`].outcome == null) {
      this.playersData[`play_session_${this.timesPlayedGame}`].outcome = {};
    }
    this.playersData[`play_session_${this.timesPlayedGame}`].outcome = {
      scores,
      status,
      result,
    };

    // console.log('setPlayersOutcome', this.playersData);
  }

  set updateOnboardingStep(type) {
    this._seenOnboarding[type] = true;
  }

  get getLastScenarioPlayed() {
    return this.playersData[`play_session_${this.timesPlayedGame}`].scenarios_order[
      this._playerProgress.currentTimeIndex + 1
    ];
  }

  get getPlayersTrackingData() {
    return this.playersData;
  }

  get onboardingSteps() {
    return this._seenOnboarding;
  }

  get currentTimeIndex() {
    return this._playerProgress.currentTimeIndex;
  }

  get currentTime() {
    return TIMELINE_BY_ID[this._playerProgress.currentTimeIndex];
  }

  get currentScenarioId() {
    return this._playerProgress.playedScenariosById[
      this._playerProgress.currentTimeIndex.length + 1
    ];
  }

  get getSessionStartTime() {
    return this.sessionStartTime;
  }

  get getTimesPlayed() {
    return this.timesPlayedGame;
  }
}
